import React from 'react';
import clsx from "clsx";
import {Progress} from "presentation/common";
import {
  BikeIcon,
  BikePlate,
  CancelledIcon,
  CarIcon,
  FolderBackground,
  PendingBg,
  ReturnedIcon,
  VehiclePlate
} from "./components";

import styles from './document-item.module.scss';

export const Background = ({doc}) => {
  if (doc.request_status === 'PENDIENTE') {
    return <PendingBg vin={doc.vin} createdAt={doc.createdAt}/>
  }

  const statusIcon = doc.request_status === 'CANCELADO'
    ? <CancelledIcon />
    : doc.request_status === 'DEVUELTO'
      ? <ReturnedIcon />
      : null;

  return <FolderBackground
    statusIcon={statusIcon}
    vin={doc.vin}
    createdAt={doc.createdAt}
    vehicleIcon={doc.tipo_vehiculo === 'MOTO' ? <BikeIcon/> : <CarIcon/>}
    plate={doc.tipo_vehiculo === 'MOTO' ? <BikePlate ppu={doc.patente}/> : <VehiclePlate ppu={doc.patente}/>}/>;
}

export const DocumentItem = ({doc, onClick}) => {
  const progressIsActive =
    doc.request_status === 'PENDIENTE' ||
    doc.request_status === 'EN_PROCESO' ||
    doc.request_status === 'TRAMITE_PENDIENTE';

  return (
    <div className={clsx(styles.container, styles[doc.request_status.toLowerCase()])} onClick={() => onClick(doc.unique_id)}>
      <Background doc={doc} data-tip data-for="returnedTooltip" />

      {
        progressIsActive &&
        <Progress progress={doc.request_progress} className={styles.progress}/>
      }

      <p>{doc.statusName}</p>
    </div>
  );
};
